export default __webpack_public_path__ + "static/media/logo.17f102da.png";